module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-flow-01-af3d8696b1e8d4dc6c2cd2409d404962.png";